import React from 'react';
import axios from 'axios';
import { Card, CardBody, Col, Row, ButtonGroup, Button, FormGroup, Label, Input, Alert, FormText } from 'reactstrap';
import classNames from 'classnames';

class ImportData extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            selectedFile: null,
            loaded: 0,
            loading: false,
            errors: {},
            response: {
                error: false,
                message: '',
            },
            activeFile: 1
        }
        this.api = '/api/v1';

        this.onClickHandler = this.onClickHandler.bind(this)
        this.onChangeHandler = this.onChangeHandler.bind(this)
    }

    onChangeHandler = event => {
        this.setState({
            selectedFile: event.target.files[0],
            loaded: 0,
        })
    }

    onClickHandler = () => {
        const { activeFile } = this.state;

        const data = new FormData()
        let url = ''
        data.append('file', this.state.selectedFile)

        this.setState({
            loading: true
        })

        if (activeFile == 1) {
            //dati vari
            url = `${this.api}/import-data`
        } else if (activeFile == 2) {
            //prediction
            url = `${this.api}/import-predictions`
        } else if (activeFile == 3) {
            url = `${this.api}/import-document`
        }

        axios.post(url, data, {}
        ).then(res => {
            let response = {
                error: false,
                message: '',
                data: []

            }

            if (res.data.status == 200) {
                // response.message = "Il caricamento è andato a buon fine: sono state salvate le righe " + res.data.data.success.join() + ". Sono stati trovati errori (celle vuote o contenenti dati non numerici o mancata corrispondenza con i clienti del database) nelle seguenti celle: " + res.data.data.errors.join()
                response.data = res.data.data
            }

            this.setState({
                loading: false,
                response,
                loaded: 100,
            })
        }).catch((err) => {
            const response = {
                error: true,
                message: 'Si è verificato un errore con il file caricato.',
            };
            this.setState({ response, loading: false });
        });
    }

    handleFileButtonClick(file) {
        let response = {
            error: false,
            message: '',
        }

        this.setState({
            response,
            loading: false,
            loaded: 0,
            activeFile: file
        })
    }

    render() {

        const { response, loaded, loading, activeFile } = this.state;
        let getClass = function (file) {
            if (file === activeFile)
                return 'btn-primary';
            return '';
        };

        return (
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card>
                            <h3 className="text-left m-3">IMPORTA DOCUMENTO</h3>
                            <CardBody>
                                <Row>
                                    <Col md="12">
                                        <ButtonGroup>
                                            <Button key="1" onClick={this.handleFileButtonClick.bind(this, 1)} className={getClass(1)}>FATTURATO</Button>
                                            <Button key="2" onClick={this.handleFileButtonClick.bind(this, 2)} className={getClass(2)}>STIMA</Button>
                                            <Button key="3" onClick={this.handleFileButtonClick.bind(this, 3)} className={getClass(3)}>DOCUMENTI</Button>
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    {response.error &&
                                        <Alert className="m-3" color="danger">
                                            <span>{response.message}</span>
                                        </Alert>}
                                </Row>
                                <Row className="mt-3">
                                    <Col className="pr-md-1" md="4">
                                        <FormGroup>
                                            <Label for="exampleFile">Inserisci un file</Label>
                                            <Input type="file" name="file" id="excelFile" onChange={this.onChangeHandler} />
                                            <FormText color="muted">
                                                Clicca qui per selezionare il file</FormText>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="mt-5 mb-5">
                                        {loaded == 100 &&
                                            <Alert color="primary">
                                                <h1>Documento caricato</h1>
                                                <p>Il caricamento è andato a buon fine</p>
                                            </Alert>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Button
                                            onClick={this.onClickHandler}
                                            color="primary"
                                            className={classNames('btn-primary mt-3', {
                                                'btn-loading': loading,
                                            })}
                                            disabled={loading}>Invia Dati</Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }

}
export default ImportData